export const EVENT_NAMES = {
  carTileClick: 'carTileClick',
  quickLinkClick: 'quickLinkClick',
  anchorTagClick: 'ctaClick',
  recommendedCarImpression: 'recommendedCarImpression',
  recommendedCarClick: 'recommendedCarClick',
  chatInitiated: 'chatInitiated',
  chatSubmission: 'chatSubmission',
  saveSearch: 'saveSearch',
  pageState: 'pageState',
  financeLeadInitiation: 'financeLeadInitiation',
  calculatorInitiated: 'calculatorInitiated',
  calculatorSubmitted: 'calculatorSubmitted',
  searchInitiated: 'searchInitiated',
  saveCar: 'saveCar',
  pageLoad: 'pageLoad',
  carCompareClick: 'carCompareClick',
  sortClick: 'sortClick',
  notifyMeInitiated: 'notifyMeInitiated',
  notifyMeSubmitted: 'notifyMeSubmitted',
  userLocationChangeSubmit: 'userLocationChangeSubmit',
  photoInteraction: 'photoInteraction',
  searchResultTileClick: 'searchResultTileClick',
  saveSearchSubmit: 'saveSearchSubmit',
  userLocationChangeInit: 'userLocationChangeInit',
  reservationAndInstantOfferStatus: 'reservationAndInstantOfferStatus',
} as const;

/**
 * All event payloads must extend this.
 */
export interface IBaseTagPayload {
  event: Event | string;
}

/** minimal shape of a click event needed to derive linkName from the target's text */
export interface IAnchorClickEvent {
  currentTarget: EventTarget | null;
  preventDefault(): void;
}

export type Event = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
